export const sharedPathes = {
  WALLET: '/wallet',
  PROFILE: '/profile',
  LOGIN_PHONE_NUMBER: '/login-phone-number',
  TECHNICAL_DIAGNOSIS: '/technical-diagnosis',
  TAXI_PASSENGER_LOADING_FLOW: '/taxi-passenger/cost-payment?baseScan=true',
  LOGIN_OTP: '/login-otp',
  VERIFY_LEVEL2: '/login-otp?verfiyLevel2=true',
  HOME: '/home',
  SETTING: '/setting',
  FAQ: '/faq',
  ABOUT_SHAHRZAD: '/about-shahrzad',
  LOGIN_USERNAME: '/login-username',
  ON_BOARDING: '/on-boarding',
  REFERRAL_CODE: '/referral-code',
  PRIVACY: '/privacy',
  CINEMA: '/festival-tickets',
  OFF_VPN: '/off-vpn',
  ERROR_WALLET: './error-wallet',
  NETWORK_FAILE: './network-faile',
  ERROR_500: './error-500',
  ERROR_504: './error-504',
  ERROR_503: './error-503',
  ERROR_502: './error-502',
  ERROR_403: './error-403',
  ERROR_401: './error-401',
  ERROR_Page_Not_Found: './error-page-not-found',
  ERROR_400: './error-400',
  ADD_VEHICLE: "/add-vehicle",
  VEHICLE_INFORMATION:"/vehicle-information",
  DEBT_RECORDS: "/debt-records",
  DEBT_FACTOR: "/debt-factor",
  DEBT_SUCCESS_PAGE: "/debt-success-page",
  DEBT_FAIL_PAGE: "/debt-fail-page",
  SELECT_VEHICLE: "/select-vehicle",
}
